<template>
  <div class="generate-order">
    <div class="generate-order-container container">
      <e-search
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :width="filterInfo.width"
        @handleFilter="handleFilter"
        @handleReset="reset"
      ></e-search>
    </div>
    <div class="container" style="padding: 20px">
      <div v-if="myPurchaseRequestData.length > 0" class="generate-order-top">
        <div class="generate-order-top-left">
          <div class="generate-order-top-left-input">
            <input
              v-if="totalCount != selectCount"
              id="allSelect"
              v-model="checked"
              type="checkbox"
              :class="{ 'no-border': totalCount != selectCount }"
              @click="checkAll"
            />
            <div v-else class="check-img">
              <img
                src="../../../../../assets/img/purchase/right.svg"
                alt=""
                @click="checkAll"
              />
            </div>
            <p>全选采购申请明细</p>
          </div>
          <div class="generate-order-top-left-sort" @click="sortChange">
            <eui-btn
              type="text"
              :icon="isSort ? 'eicon-arrow-up' : 'eicon-arrow-down'"
              >按接收时间排序</eui-btn
            >
            <!--            <img-->
            <!--              v-show="!isSort"-->
            <!--              src="../../../../../assets/img/purchase/up copy.png"-->
            <!--              alt=""-->
            <!--            />-->
            <!--            <img-->
            <!--              v-show="isSort"-->
            <!--              src="../../../../../assets/img/purchase/down copy.png"-->
            <!--              alt=""-->
            <!--            />-->
          </div>
        </div>
        <div class="generate-order-top-right-wrap">
          <div
            class="generate-order-top-right"
            @mouseenter="enter(true)"
            @mouseleave="leave(false)"
          >
            <img
              v-show="!isDel"
              src="../../../../../assets/img/purchase/del.png"
              alt=""
            />
            <img
              v-show="isDel"
              src="../../../../../assets/img/purchase/del_active.png"
              alt=""
            />
            <div
              :class="{ 'text-color': isDel }"
              @click="deleteSelectedPurchaseRequest"
            >
              删除已选采购申请
            </div>
          </div>
          <div class="generate-order-top-right spe">
            <div @click="goEnquiry">发起询价</div>
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in myPurchaseRequestData"
        :key="index"
        class="generate-order-main"
        :class="{ 'is-active': checkModel.indexOf(item.prItemId) !== -1 }"
      >
        <div class="order-item" :class="{ 'margin-l': index == 9 }">
          <div class="index-item">{{ index + 1 }}</div>
          <div class="order-item-main">
            <div v-if="isSelect(item)" class="left-line"></div>
            <div class="order-item-left">
              <input
                v-model="checkModel"
                type="checkbox"
                :value="item.prItemId"
                :class="{
                  'no-border':
                    typeof item.prPurchasLlistVOs == 'undefined' ||
                    checkModel.indexOf(item.prItemId) == -1,
                }"
                class="img-input"
                @change="checkPurchaseRequest(item, index)"
              />
              <div
                v-if="checkModel.indexOf(item.prItemId) != -1"
                class="img-right"
                @click="cancleClick(item, index)"
              >
                <img
                  src="../../../../../assets/img/purchase/right.svg"
                  alt=""
                />
              </div>
            </div>
            <div class="order-item-middle">
              <ul>
                <li>
                  <div
                    class="text break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    采购申请号：
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.requestno"
                    placement="top"
                  >
                    <span class="ellipsis width text-value">
                      {{ item.requestno }}
                    </span>
                  </el-tooltip>
                  <!-- <div class="text-value requestno">{{ item.requestno }}</div> -->
                </li>
                <li>
                  <div
                    class="text break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    商品行号：
                  </div>
                  <div class="text-value">{{ item.itemno }}</div>
                </li>
                <li>
                  <div
                    class="text break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    商品名称：
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.prodname"
                    placement="top"
                    :manual="item.prodname.length >= 20 ? false : true"
                  >
                    <div class="text-value text-value-number ellipsis">
                      {{ item.prodname }}
                    </div>
                  </el-tooltip>
                </li>
                <li class="li-width-196 break-box">
                  <div
                    class="text"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    商品规格：
                  </div>
                  <e-tooltip :content="item.spec" :set-length="20" />
                </li>
                <li>
                  <div
                    class="text text100 break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    期望到货时间：
                  </div>
                  <div class="text-value t-132">{{ item.arriveTimeTxt }}</div>
                </li>
                <li>
                  <div
                    class="text text100 break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    平台接收时间：
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.createTime"
                    placement="top"
                  >
                    <div class="text-value t-132">{{ item.createTime }}</div>
                  </el-tooltip>
                </li>
                <li>
                  <div
                    class="text break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    应采数量：
                  </div>
                  <div class="text-value">{{ item.intqty }}</div>
                </li>
                <li>
                  <div
                    class="text break-box"
                    :class="{
                      isActive: checkModel.indexOf(item.prItemId) !== -1,
                    }"
                  >
                    剩余应采数量：
                  </div>
                  <div class="text-value ellipsis">
                    {{
                      item.remainingQuantity != null
                        ? item.remainingQuantity
                        : item.intqty
                    }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="order-item-right">
            <div
              :class="{ selectBtn: checkModel.indexOf(item.prItemId) !== -1 }"
              class="selectBtnDefault"
              @click="selectBtn(item.prItemId, item.prodname)"
            >
              选择商品
            </div>
          </div>
        </div>
        <div v-if="isSelect(item)" class="order-item-footer">
          <div class="commodity">
            <img
              src="../../../../../assets/img/purchase/commodity.png"
              alt=""
            />
            <div class="order-item-footer-text">
              <p
                class="text break-box"
                :class="{ isActive: checkModel.indexOf(item.prItemId) !== -1 }"
              >
                商品名称：
              </p>
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.prPurchasLlistVOs[0].productName"
                placement="top"
              >
                <span class="ellipsis width text-value">
                  {{ item.prPurchasLlistVOs[0].productName }}
                </span>
              </el-tooltip>
            </div>
          </div>
          <div>
            <p
              class="text break-box"
              :class="{ isActive: checkModel.indexOf(item.prItemId) !== -1 }"
            >
              商品规格：
            </p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                setShoppingStandard(item.prPurchasLlistVOs[0].extendedInfo)
              "
              placement="top"
            >
              <span class="text-width-150 ellipsis text-value">
                {{
                  setShoppingStandard(item.prPurchasLlistVOs[0].extendedInfo)
                }}
              </span>
            </el-tooltip>
          </div>
          <div>
            <p
              class="text break-box"
              :class="{ isActive: checkModel.indexOf(item.prItemId) !== -1 }"
            >
              供应商:
            </p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.prPurchasLlistVOs[0].supplierCompany"
              placement="top"
            >
              <span class="text-width-150 ellipsis text-value">
                {{ item.prPurchasLlistVOs[0].supplierCompany }}
              </span>
            </el-tooltip>
          </div>
          <div class="order-size">
            <p
              class="text break-box"
              :class="{ isActive: checkModel.indexOf(item.prItemId) !== -1 }"
            >
              采购数量
            </p>
            <!--    <el-input-number  v-model="item.prPurchasLlistVOs[0].quantity"-->
            <!--      @change="handleChange(item.prPurchasLlistVOs[0].quantity,item.prPurchasLlistVOs[0].sinoPrPurchaseListId)"-->
            <!--      :min="1" label="描述文字"></el-input-number>-->
            <div class="lw-3">
              <e-buy-num
                :e-height="30"
                :num.sync="item.prPurchasLlistVOs[0].quantity"
                :item-data="item.prPurchasLlistVOs[0]"
                @edit-num="
                  handleChange(
                    item.prPurchasLlistVOs[0].quantity,
                    item.prPurchasLlistVOs[0].sinoPrPurchaseListId
                  )
                "
              ></e-buy-num>
            </div>
          </div>
        </div>
        <img
          v-show="isSelect(item)"
          src="@/assets/img/purchase/line.png"
          alt=""
          class="line-item"
        />
      </div>
      <div v-if="noDataFlag" class="no-data">
        <!-- <img src="../../../assets/images/orderDetail/order-no.png" alt="" /> -->
        <p>贵公司当前暂无采购申请</p>
        <!-- <p>
          请
          <span @click="toSelect">选择商品</span>
          下单
        </p> -->
      </div>
      <div class="pagination-box">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="formInline.page"
          :total="formInline.total"
          :page-size.sync="formInline.limit"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div v-if="!noDataFlag" id="orderNow" class="order-now">
        <div class="order-now-left">
          <input
            v-if="totalCount != selectCount"
            v-model="checked"
            type="checkbox"
            :class="{ 'no-border': totalCount != selectCount }"
            @click="checkAll"
          />
          <div v-else class="check-img">
            <img
              src="../../../../../assets/img/purchase/right.svg"
              alt=""
              @click="checkAll"
            />
          </div>
          <span class="choose">已选</span>
          <span class="red margin-both">
            {{ selectCount }}
          </span>
          条采购申请
        </div>
        <div class="order-now-right">
          <div class="detail">
            <div class="all">
              合计金额：
              <span class="red">¥ {{ moneySum }}</span>
            </div>
          </div>
          <div class="button">
            <!-- <img src="../../../assets/images/orderDetail/order-now.png" alt="" /> -->
            <div @click="setOrder">立即订购</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { durationTime } from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/purchase';
import { orderBaseUrl } from '@/modules/projectA/api/config';
import eBuyNum from './e-buy-num-product';
import eSearch from '../../../components/common/e-search';
import eTooltip from '../../../components/common/e-tooltip';

export default {
  name: 'GenerateOrder',
  components: { eBuyNum, eTooltip, eSearch },
  data() {
    return {
      filterInfo: {
        data: {
          requestNo: null,
          saveStatus: null,
          prodname: null,
          apimaterNo: null,
          itemno: null,
        },
        fieldList: [
          { label: '采购申请号', type: 'input', value: 'requestNo' },
          {
            label: '商品是否保存',
            type: 'select',
            value: 'saveStatus',
            list: 'saveStatusList',
          },
          { label: '项目编号', type: 'input', value: 'itemno' },
          { label: '商品名称', type: 'input', value: 'prodname' },
          { label: '企业物料编码', type: 'input', value: 'apimaterNo' },
        ],
        width: {
          labelWidth: 130,
          itemWidth: 160,
        },
      },
      listTypeInfo: {
        saveStatusList: [
          { id: null, name: '全部' },
          { id: 0, name: '是' },
          { id: 1, name: '否' },
        ],
      },
      noDataFlag: false,
      isFixed: false,
      toSubmitFlag: true,
      checked: false,
      user: '',
      formInline: {
        requestNo: null,
        saveStatus: null,
        prodname: null,
        apimaterNo: null,
        itemno: null,
        createTimeSort: 'DESC',
        limit: 10, // 每页条数
        page: 1, // 页码
        total: 0,
        clickQuery: 0, // 固定传0
        track: 0,
      },
      user1: '',
      user2: '',
      user3: '',
      options: [
        {
          value: null,
          label: '全部',
        },
        {
          value: '0',
          label: '是',
        },
        {
          value: '1',
          label: '否',
        },
      ],
      num: '1',
      isSort: false,
      isDel: false,
      isBtnLight: false,
      checkModel: [],
      totalCount: 0,
      selectCount: 0,
      myPurchaseRequestData: [], // 申请数据明细，操作数据
      moneySum: 0,
      checkedNum: 0,
      orderList: [],
      addressList: [],
      activeAddress: {},
      invoeicList: [], // 发票列表
      activeInvoeicItem: {},
      invoiceInfo: [],
      activeInvoice: {},
      approvalList: [],
    };
  },
  watch: {
    // 监视双向绑定的数据数组
    checkModel() {
      if (this.checkModel.length === this.checkedNum && this.checkedNum > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    myPurchaseRequestData: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            window.addEventListener('scroll', this.initHeight);
          });
        }
      },
    },
    deep: true,
  },
  mounted() {
    window.addEventListener('scroll', this.initHeight);
    this.queryPurchaseRequestList();
  },
  destroyed() {
    window.removeEventListener('scroll', this.initHeight);
  },
  methods: {
    handleFilter(val) {
      this.formInline.requestNo = val.requestNo;
      this.formInline.saveStatus = val.saveStatus;
      this.formInline.prodname = val.prodname;
      this.formInline.apimaterNo = val.apimaterNo;
      this.formInline.itemno = val.itemno;
      this.formInline.page = 1;
      this.queryPurchaseRequestList();
    },
    setOrder() {
      if (this.checkModel.length === 0) {
        this.$message.warning('请先勾选采购申请，再操作立即订购。');
        return;
      }
      // 有选中的商品
      let isSelect = false;
      for (let i = 0; i < this.myPurchaseRequestData.length; i++) {
        // eslint-disable-next-line no-loop-func
        this.checkModel.forEach((item) => {
          if (
            item === this.myPurchaseRequestData[i].prItemId &&
            this.myPurchaseRequestData[i].prPurchasLlistVOs &&
            this.myPurchaseRequestData[i].prPurchasLlistVOs.length > 0 &&
            Number(
              this.myPurchaseRequestData[i].remainingQuantity != null
                ? this.myPurchaseRequestData[i].remainingQuantity
                : this.myPurchaseRequestData[i].intqty
            ) > 0
          ) {
            isSelect = true;
          }
        });
      }
      if (isSelect) {

        window.open(`${orderBaseUrl}/order?from=v&flag=myPurchaseRequest`, '_blank');

      } else {
        this.$message({
          message: '您当前勾选的采购申请还未选择商品，请先完成商品选择。',
          type: 'warning',
          duration: durationTime(),
        });
      }
    },
    sortChange() {
      this.isSort = !this.isSort;
      this.queryPurchaseRequestList();
    },
    // 判断是否有选中商品 和 剩余数量是否 大于0
    isSelect(item) {
      if (
        typeof item.prPurchasLlistVOs !== 'undefined' &&
        Number(
          item.remainingQuantity != null &&
            item.remainingQuantity !== 'undefined'
            ? item.remainingQuantity
            : item.intqty
        ) > 0
      ) {
        return true;
      }
      return false;
    },
    // 初始化数据
    async queryPurchaseRequestList(data) {
      if (this.isSort) {
        this.formInline.createTimeSort = 'DESC';
      } else {
        this.formInline.createTimeSort = 'ASC';
      }
      if (data) {
        this.formInline.page = 1;
      }

      const res = await Api.queryPurchaseRequestList(this.formInline);
      if (res.code === '200') {
        this.totalCount = res.data.totalCount; // 供应商下所有订单采购的数量
        this.selectCount = res.data.selectCount; // 选的条数

        this.myPurchaseRequestData = res.data.purchaseRequestListVOs
          ? res.data.purchaseRequestListVOs
          : [];

        this.checkedNum = 0;
        if (this.myPurchaseRequestData.length === 0) {
          this.noDataFlag = true;
          return;
        }
        this.myPurchaseRequestData.forEach((item) => {
          if (this.isSelect(item)) {
            this.checkedNum++;
          }
        });

        this.noDataFlag = false;

        this.formInline.total = res.data.totalCount;

        for (let i = 0; i < this.myPurchaseRequestData.length; i++) {
          if (
            this.myPurchaseRequestData[i].isSelected === 1 &&
            this.checkModel.findIndex(
              (item) => item === this.myPurchaseRequestData[i].prItemId
            ) === -1
          ) {
            this.checkModel.push(this.myPurchaseRequestData[i].prItemId);
          }
        }
        this.moneySum = res.data.totalAmount;
      }
    },
    // 采购申请 每条类目选中或取消返回总价
    async cancleClick(item) {
      const res = await Api.checkPurchaseRequest({
        checkedStatus: 0,
        prItemId: item.prItemId,
      });
      if (res.code === '200') {
        this.moneySum = res.data;
      }
      this.checkModel.splice(
        this.checkModel.findIndex((itemData) => itemData === item.prItemId),
        1
      );

      this.queryPurchaseRequestList();
    },
    // 采购申请全部选中或取消返回总价
    async checkPurchaseRequest(item) {
      const num = this.checkModel.findIndex(
        (itemData) => itemData === item.prItemId
      );
      const res = await Api.checkPurchaseRequest(
        !item
          ? { prItemId: '', checkedStatus: this.checkModel.length > 0 ? 1 : 0 }
          : { checkedStatus: num === '-1' ? 0 : 1, prItemId: item.prItemId }
      );
      if (res.code === '200') {
        this.moneySum = res.data;

        this.queryPurchaseRequestList();
      }
    },
    reset() {
      this.formInline = {
        requestNo: null,
        saveStatus: null,
        prodname: null,
        createTimeSort: 'DESC',
        limit: 10, // 每页条数
        page: 1, //
        total: 0,
        clickQuery: 0,
        track: 0,
      };
      this.queryPurchaseRequestList();
    },
    // 翻页
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.queryPurchaseRequestList();
    },
    handleSizeChange() {
      this.formInline.page = 1;
      // eslint-disable-next-line no-undef
      this.formInline.limit = val;
      this.queryPurchaseRequestList();
    },
    setShoppingStandard(param) {
      let content = '';
      if (param) {
        try {
          const data = JSON.parse(param);
          for (let i = 0; i < data.length; i++) {
            content += `${data[i].salesPropertyInfoName}:${data[i].salesPropertyInfoValue};`;
          }
        } catch (e) {
          console.log(e);
        }
      }
      return content;
    },
    async handleChange(num, value) {
      const res = await Api.updatePurchaseRequestQuantity({
        quantity: num || 0,
        sinoPrPurchaseListId: value,
      });
      if (res.code === '200') {
        this.moneySum = res.data;
        this.toSubmitFlag = true;
      } else {
        this.toSubmitFlag = false;
      }
    },
    selectBtn(value, prodname) {
      this.$router.push({
        path: `/myPurchaseRequest/checked`,
        query: { prItemId: value, prodname },
      });
    },
    enter(value) {
      this.isDel = value;
    },
    leave(value) {
      this.isDel = value;
    },
    checkAll() {
      if (this.checkModel.length > 0) {
        this.checkModel = [];
      } else {
        this.myPurchaseRequestData.forEach((item) => {
          if (this.checkModel.indexOf(item.prItemId) === -1) {
            this.checkModel.push(item.prItemId);
          }
        });
      }
      this.checkPurchaseRequest('', '');
    },
    toSelect() {
      this.$router.push({ path: '/' });
    },
    // 发起询价
    goEnquiry() {
      if (this.checkModel.length === 0) {
        this.$message({
          message: '请选择需要询价的采购申请。',
          type: 'warning',
          duration: durationTime(),
        });
        return;
      }
      this.$router.push({
        path: '/enquiryManage/enquiryIss',
        query: {
          type: 'integrated',
        },
      });
    },
    // 删除已选采购申请
    async deleteSelectedPurchaseRequest() {
      if (this.checkModel.length === 0) {
        this.$message({
          message: '请选择要删除的采购申请。',
          type: 'warning',
          duration: durationTime(),
        });
        return;
      }

      this.$confirm(`您正在操作删除已选采购申请，请仔细核对并确认。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        const res = await Api.deletePurchaseRequest({});
        if (res.code === '200') {
          this.$message({
            message: '删除已选采购申请成功',
            type: 'success',
            duration: durationTime(),
          });
          this.checkModel = [];
          this.queryPurchaseRequestList();
        }
      });
    },
    initHeight() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // scrollTop = scrollTop+634;
      // console.log(scrollTop, '这是scrollTop');
      // let height =  document.documentElement.clientHeight || document.body.clientHeight;
      // let scorllHeight =  document.body.scrollHeight  ||document.documentElement.scrollHeight;
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;

      const div = document.getElementById('orderNow');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      if (scrollTop + height < divToTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/mixin/flex.scss';
.generate-order {
  padding: 10px;
  .no-border {
    -webkit-appearance: none;
    border: 1px solid #dcdfe6;
    width: 18px;
    height: 18px;
  }
  .check-img {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: #2587ff;
    img {
      width: 11px;
      height: 8px;
      margin-top: 2px;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text-value {
    color: #333;
    font-size: 14px;
  }
  .generate-order-container {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    margin-bottom: 20px;
    ::v-deep .el-form {
      .el-form-item__label {
        color: #333;
      }
      .el-form-item {
        input::-webkit-input-placeholder {
          color: #999;
        }
        input::-moz-input-placeholder {
          color: #999;
        }
        input::-ms-input-placeholder {
          color: #999;
        }
      }
    }

    .button {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      margin-top: 6px;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }

      .reset-btn {
        width: 80px;
        height: 30px;
        border: 1px solid #dcdfe6;
        color: #333;
        margin-right: 30px;
        font-size: 14px;
        &:hover,
        :active {
          background-color: #bedbff;
          border: 1px solid #bedbff;
          color: #2587ff;
        }
      }
      .submit-btn {
        font-size: 14px;
        color: #2587ff;
        border: 1px solid #2587ff;
        &:hover,
        :active {
          background-color: #e8efff;
        }
      }
    }

    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__content {
          input {
            width: 200px;
            height: 30px;
            line-height: 30px;
          }

          .el-range-input {
            width: 80px;
          }

          .el-range-separator {
            width: 30px;
          }

          .el-date-editor {
            width: 200px;
          }

          .el-button:focus,
          .el-button:hover {
            color: #333333;
            background-color: transparent;
          }

          .el-checkbox-group {
            margin-left: 70px;
            .is-checked + .el-checkbox__label {
              color: #333333;
            }
          }

          .el-date-editor {
            height: 30px;

            i:nth-child(1) {
              display: none;
            }

            .el-range__close-icon {
              line-height: 22px;
            }

            input {
              height: 25px;
            }

            .el-range-separator {
              height: 25px;
              line-height: 25px;
            }
          }

          .el-button {
            padding: 9px 27px;
          }

          .reset-btn {
            margin: 0 20px 0 80px;
          }
        }
      }
    }
  }
  ::v-deep.el-input__inner {
    border-radius: 0;
    color: #333;
  }

  .generate-order-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 10px 20px;
    border: 1px solid #d9d9d9;
    margin-bottom: 10px;
    box-sizing: border-box;

    ::v-deep .el-checkbox__label {
      font-weight: bold;
      color: #333333;
    }

    .generate-order-top-left {
      display: flex;
      align-items: center;

      .generate-order-top-left-input {
        display: flex;
        align-items: center;

        input[type='checkbox'] {
          cursor: pointer;
          position: relative;
          width: 18px;
          height: 18px;
          -webkit-appearance: none;
        }

        input[type='checkbox']::after {
          position: absolute;
          top: 0;
          color: #000;
          width: 18px;
          height: 18px;
          display: inline-block;
          visibility: visible;
          padding-left: 0px;
          text-align: center;
          content: '';
        }
        p {
          margin-left: 10px;
          font-weight: bold;
        }
      }

      .generate-order-top-left-sort {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-left: 40px;
        box-sizing: border-box;

        img {
          width: 13px;
          height: 15px;
          margin-left: 10px;
        }
      }
    }

    .generate-order-top-right-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      .spe {
        margin-left: 20px;
        padding-left: 10px;
        background: url('~@/assets/img/purchase/enquiry_off.png') no-repeat
          center left;
        background-size: 14px 16px;
      }
      .spe:hover {
        color: #0064c8;
        background-image: url('~@/assets/img/purchase/enquiry_on.png');
      }
      .generate-order-top-right {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 14px;
          height: 16px;
        }

        div {
          margin-left: 10px;
        }

        .text-color {
          color: #0064c8;
        }
      }
    }
  }
  .is-active {
    background-color: #f4f7ff;
  }
  .generate-order-main {
    display: flex;
    flex-direction: column;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    position: relative;
    padding: 10px 0;

    .margin-l {
      margin-left: -8px;
    }
    .order-item {
      // width: 1086px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .index-item {
        padding-right: 20px;
        /*width: 40px;*/
        /*margin-right: 20px;*/
      }
      .order-item-main {
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
        // border-left: 1px solid #d9d9d9;
        position: relative;
        width: 100%;
        .left-line {
          position: absolute;
          border-left: 1px solid #d9d9d9;
          width: 1px;
          height: 54px;
          left: -1px;
          top: 69px;
          display: none;
        }
        // .order-item-left ::after {
        //   content: '';
        //   position: absolute;
        //   top: 12px;
        //   left: 20px;
        //   width: 1px;
        //   height: 100%;
        //   background-color: #d9d9d9;
        // }
        .order-item-left {
          padding-top: 12px;
          box-sizing: border-box;
          img {
            width: 12px;
            height: 12px;
          }
          .img-input {
            position: relative;
          }
          .img-right {
            width: 18px;
            height: 18px;
            position: absolute;
            top: 12px;
            left: 21px;
            background-color: #2587ff;
            line-height: 18px;
            text-align: center;
            img {
              margin-top: 4px;
              width: 12px;
            }
          }

          input[type='checkbox'] {
            cursor: pointer;
            position: relative;
            width: 18px;
            height: 18px;
            border-radius: 0;
            -webkit-appearance: none;
          }
          // input[type=checkbox]:checked{
          //   background: url("../../../assets/images/right.svg") no-repeat #2587FF;
          //   background-position: 4px 6px;
          //   background-size: 11px 8px;
          //   width: 18px;
          //   height: 18px;
          // }
          input[type='checkbox']::after {
            color: #000;
            width: 18px;
            height: 18px;
            display: inline-block;
            visibility: visible;
            padding-left: 0px;
            text-align: center;
          }
        }

        .order-item-middle {
          width: 100%;
          ul {
            display: flex;
            flex-wrap: wrap;
            // width: 896px;

            li {
              display: flex;
              width: 12%;
              padding: 8px 0 14px;
              box-sizing: border-box;
              align-items: center;
              &:nth-of-type(4n + 1) {
                margin-left: 15px;
              }
              &:nth-of-type(4n + 2),
              &:nth-of-type(4n + 3) {
                margin-left: 4px;
              }

              .text {
                color: #999;
                font-size: 12px;
              }

              .text86 {
                width: 104px;
              }

              .text70 {
                width: 80px;
              }

              .text75 {
                width: 75px;
              }

              .text85 {
                width: 80px;
              }

              .text100 {
                width: 106px;
              }
              .text99 {
                width: 114px;
              }

              .text115 {
                width: 115px;
              }

              .isActive {
                color: #333;
              }
              .break-box {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .requestno {
                max-width: 104px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .text-value {
                color: #333;
                font-size: 14px;
              }
              .t-132 {
                width: 132px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .text-value-number {
                width: 80px;
              }

              .text-value-number150 {
                width: 150px;
              }
            }

            li:nth-child(n + 5) {
              // padding: 0 0 15px 0;
              box-sizing: border-box;
            }

            .li-width-196 {
              width: 196px;
            }
          }
        }
      }

      .order-item-right {
        position: relative;
        // left: -164px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .selectBtnDefault {
          width: 80px;
          height: 30px;
          line-height: 27px;
          color: #2587ff;
          text-align: center;
          border: 1px solid #2587ff;
          background: #fff;
          box-sizing: border-box;
          cursor: pointer;
          font-size: 14px;
          &:hover {
            background: #e9f3ff;
            color: #2587ff;
          }
        }

        .selectBtn {
          border: 1px solid #2587ff;
          background: #f4f7ff;
          box-sizing: border-box;
          color: #2587ff;
          font-size: 14px;
          &:hover,
          :active {
            background: #e9f3ff;
            color: #2587ff;
          }
        }
      }
    }
    .line-item {
      margin-left: 35px;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
    .left-item {
      padding-left: 40px;
    }
    .order-item-footer {
      // width: 802px;
      display: flex;
      // align-items: center;
      padding: 10px 10px 10px 0;
      border: 1px solid #dcdcdc;
      box-sizing: border-box;
      margin: 0 20px 10px 101px;
      justify-content: space-between;
      > div {
        display: flex;
        align-items: center;
        margin-left: 12px;

        .text {
          color: #333;
          font-size: 12px;
        }
        .isActive {
          color: #333;
        }

        .text-width-150 {
          width: 126px;
        }
      }

      .commodity {
        margin-left: 10px;
        display: flex;

        .ellipsis {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .order-item-footer-text {
          display: flex;
          margin-left: 10px;
        }
      }
      .width {
        width: 80px;
      }
      .order-size {
        p {
          padding-right: 10px;
        }
        .lw-3 {
          // flex:1;
          width: 122px;
          @include flex(center, center, row);
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
    }

    > img {
      position: absolute;
      top: 39px;
      left: 45px;
      width: 23px;
      height: 78px;
    }

    .isMainActive {
      background: #f4f7ff;
    }
  }
  .no-data {
    text-align: center;
    margin-bottom: 80px;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
  .order-now {
    height: 59px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.5);
    border: 1px solid #d9d9d9;
    z-index: 100;
    .is-fixed-wrap {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .is-fixed-left {
        width: 180px;
        height: 20px;
      }
      .is-fixed-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        width: 1010px;
        margin-left: 10px;
      }
    }
    &.is-fixed {
      position: fixed;
      bottom: 0;
      width: 100%;
      padding: 0;
      left: 0;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
      z-index: 999;
    }
    .red {
      color: red;
    }
    .margin-both {
      margin: 0 10px;
    }
    .order-now-left {
      margin-left: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      .choose {
        margin-left: 16px;
      }
    }
    .order-now-right {
      display: flex;
      align-items: center;

      .detail {
        .all {
          font-weight: bold;
          color: #333333;
          font-size: 16px;
        }
        span {
          margin-right: 10px;
        }
      }
      .button {
        height: 60px;
        line-height: 60px;
        width: 130px;
        text-align: center;
        background-color: red;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        cursor: pointer;
        img {
          width: 16px;
          height: 22px;
        }
      }
    }
  }
  .pagination-box {
    text-align: right;
  }
}
</style>
